import React from 'react';
import PropTypes from 'prop-types';
import { useEditableEmailValidator } from '../hooks/useEditableEmailValidator';

export default function EmailValidatorAlert({
  fieldName,
  cardId,
  emailDomains,
}) {
  const { error, info } = useEditableEmailValidator({
    fieldName,
    cardId,
    emailDomains,
  });

  const safeId = cardId || fieldName;
  const infoId = `email-info-${safeId}`;
  const errorId = `email-error-${safeId}`;

  return (
    <>
      {info.length > 0 && (
        <div
          id={infoId}
          role="status"
          className="alert alert-info"
          aria-live="polite"
          aria-atomic="true"
        >
          {info.map((msg, i) => (
            <div key={i}>
              <i className="fa fa-info-circle" aria-hidden="true" />
              <span className="sr-only">Info:</span> {msg}
            </div>
          ))}
        </div>
      )}

      {error && (
        <div
          id={errorId}
          role="alert"
          className="alert alert-warning"
          aria-live="assertive"
          aria-atomic="true"
        >
          <i className="fa fa-exclamation-triangle" aria-hidden="true" />
          <span className="sr-only">Warning:</span> {error}
        </div>
      )}
    </>
  );
}

EmailValidatorAlert.propTypes = {
  fieldName: PropTypes.string,
  cardId: PropTypes.string,
  emailDomains: PropTypes.arrayOf(PropTypes.string),
};

EmailValidatorAlert.defaultProps = {
  fieldName: 'email',
  emailDomains: [],
};
